import React from "react";
import "./PrivacyPolicy.css";

const PrivacyPolicy = () => {
  return (
    <section className="yprivacy-policy">
      <div className="yprivacy-container">

        <h1 className="yprivacy-title">Privacy Policy</h1>

        <p className="yprivacy-intro">
          This Privacy Policy explains how personal information is collected,
          used, and protected when you visit or book travel services through
          <strong> Budget Golden Triangle Tours </strong>
          operated by <strong>City Linkers Tours & Travels</strong>.
          We are committed to protecting your privacy while providing safe,
          reliable, and comfortable travel experiences across India.
        </p>

        {/* PERSONAL INFORMATION */}
        <h2>PERSONAL INFORMATION WE COLLECT</h2>

        <p>
          When you visit our website, we automatically collect certain
          information about your device including browser type,
          IP address, time zone, and browsing behavior. This helps us
          improve website performance and customer experience.
        </p>

        <p>We collect information using the following technologies:</p>

        <ul>
          <li>
            <strong>Cookies:</strong> Used to remember preferences,
            tour selections, and enhance website functionality.
          </li>

          <li>
            <strong>Log Files:</strong> Track pages visited, traffic
            sources, and interaction with our website.
          </li>

          <li>
            <strong>Analytics Tools:</strong> Used to understand visitor
            behavior and improve our travel services.
          </li>
        </ul>

        <p>
          When you make an enquiry or booking for Golden Triangle Tours
          or other India travel packages, we may collect:
        </p>

        <ul>
          <li>Name</li>
          <li>Email address</li>
          <li>Mobile number</li>
          <li>Travel dates and passenger details</li>
          <li>Hotel and transportation preferences</li>
          <li>Payment and billing information</li>
        </ul>

        <p>
          This information is referred to as <strong>Booking Information</strong>.
        </p>

        {/* HOW WE USE INFO */}
        <h2>HOW WE USE YOUR INFORMATION</h2>

        <p>We use personal information to:</p>

        <ul>
          <li>Process tour bookings and travel enquiries</li>
          <li>Arrange hotels, transportation, and sightseeing services</li>
          <li>Send booking confirmations and travel updates</li>
          <li>Provide customer support and assistance</li>
          <li>Improve website performance and services</li>
          <li>Prevent fraudulent or unauthorized transactions</li>
        </ul>

        {/* SHARING */}
        <h2>SHARING YOUR PERSONAL INFORMATION</h2>

        <p>
          We share necessary information only with trusted partners
          required to complete travel services, including:
        </p>

        <ul>
          <li>Hotels and accommodation providers</li>
          <li>Transportation and driver services</li>
          <li>Tour guides and sightseeing partners</li>
          <li>Payment gateway providers</li>
        </ul>

        <p>
          We do not sell, rent, or trade your personal information
          to third parties.
        </p>

        {/* MARKETING */}
        <h2>MARKETING & COMMUNICATION</h2>

        <p>
          With your permission, we may send travel offers,
          tour promotions, and special package updates.
          You may unsubscribe from promotional communications
          at any time.
        </p>

        {/* DATA SECURITY */}
        <h2>DATA SECURITY</h2>

        <p>
          We implement appropriate technical and organizational
          security measures to protect your personal information
          against unauthorized access, disclosure, or misuse.
        </p>

        {/* DATA RETENTION */}
        <h2>DATA RETENTION</h2>

        <p>
          Booking and transaction information is retained only
          for operational, legal, and accounting purposes.
        </p>

        {/* MINORS */}
        <h2>MINORS</h2>

        <p>
          Our services are intended for individuals above 18 years of age.
          Bookings for minors must be made under the supervision of a
          parent or legal guardian.
        </p>

        {/* POLICY CHANGES */}
        <h2>CHANGES TO THIS POLICY</h2>

        <p>
          We may update this Privacy Policy periodically to reflect
          legal or operational changes. Updates will be posted on
          this page.
        </p>

        {/* CONTACT */}
        <h2>CONTACT US</h2>

        <p>
          If you have any questions regarding this Privacy Policy,
          please contact us:
        </p>

        <address>
          <strong>City Linkers Tours & Travels</strong><br />
          Budget Golden Triangle Tours<br />
          Flat No: 34D, Block H, Saket, New Delhi - 110017<br />
          Phone: +91-9911363366<br />
          Email:{" "}
          <a href="mailto:budgetgoldentriangletours@gmail.com">
            budgetgoldentriangletours@gmail.com
          </a>
        </address>

      </div>
    </section>
  );
};

export default PrivacyPolicy;